import { createRequestActionTypes, createActionType } from '../../helpers'

export const FETCH_FOOTPRINTS = createRequestActionTypes('FOOTPRINTS', 'FETCH')
export const SHOW_FOOTPRINTS_SEARCH = createActionType(
  'FOOTPRINTS',
  'SHOW_SEARCH'
)
export const HIDE_FOOTPRINTS_SEARCH = createActionType(
  'FOOTPRINTS',
  'HIDE_SEARCH'
)
export const HIDE_FOOTPRINTS = createActionType('FOOTPRINTS', 'HIDE')
export const SHOW_FOOTPRINTS = createActionType('FOOTPRINTS', 'SHOW')
export const UPDATE_FOOTPRINTS = createRequestActionTypes(
  'FOOTPRINTS',
  'UPDATE'
)
export const CHANGE_FORM = createActionType('FOOTPRINTS', 'CHANGE_FORM')
export const FETCH_SUGGESTIONS = createRequestActionTypes(
  'FOOTPRINTS',
  'FETCH_SUGGESTIONS'
)
export const CREATE_FOOTPRINTS = createRequestActionTypes(
  'FOOTPRINTS',
  'CREATE_FOOTPRINTS'
)
